export default __webpack_public_path__ + "static/MediaContentOneFancybox-0b39c8dd332814a048969e5ca0337e70.webp";